import { ImageComponent } from "./ImageComponent";
import { ProductCategory } from "../../../types/app/categoriesTypes";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { AddProductCategoryModal } from "./AddProductCategoryModal";
import { useState } from "react";
import { MediaPageProps } from "../../../types/app/mediaTypes";

interface ProductCategoryRowProps {
    category: ProductCategory;
    selectedIds: number[];
    onSelect: (id: number) => void;
    handleDeleteCategory: (id: number) => void;
    handleUpdateCategory: (payload: {
        name: string;
        id: number;
    }) => void;
    mediaPageProps: Pick<
        MediaPageProps,
        "getImageGalleryAction" | "getImageGalleryRequest"
    >;
}

export const ProductCategoryRow: React.FC<ProductCategoryRowProps> = ({
    category,
    selectedIds,
    onSelect,
    handleDeleteCategory,
    handleUpdateCategory,
    mediaPageProps
}) => {
    const isChecked = selectedIds.includes(category?.id);
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <tr className="category-row">
                <td>
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={(e) => onSelect(category.id)}
                        />
                        <span className="checkmark"></span>
                    </label>
                </td>
                <td className="category-name">
                    <ImageComponent imageUrl={category.image} alt={category.name || "category"} />
                    <span>{category.name || "-"}</span>
                </td>
                <td className="category-description">
                    {category.description || "-"}
                </td>
                <td className="category-count">{category.count ?? 0}</td>
                <td className="category-date">{category.created_at || "-"}</td>
                <td className="category-actions">
                    <FiEdit2 className="edit-icon" size={16} onClick={()=> setShowModal(true)} />
                    <FiTrash2 className={`delete-icon${category?.count === 0 || !category?.count ? "-disabled" : ""}`}
                        color={category?.count === 0 ? "#EC3237" : "#757575"}
                        size={16} onClick={() => {
                            if (category?.count === 0) {
                                handleDeleteCategory(category?.id)
                            }
                        }} />
                </td>
            </tr>
            <AddProductCategoryModal show={showModal} onClose={() => setShowModal(false)} id={category?.id} initValues={{
                name: category?.name ?? "",
                description: category?.description ?? "",
                icon : category?.image ?? ""
            }} handleUpdateCategory={handleUpdateCategory} type="update" mediaPageProps={mediaPageProps} />

        </>
    );
};
